// "Surferelle Page Nav" — smooth-scrolls to each linked section's Anchor ID,
// opens it first if it's a collapsed Surferelle Stage accordion, and
// highlights whichever section the reader has scrolled to.
document.addEventListener('DOMContentLoaded', function () {
  var wrap = document.querySelector('[data-sf-page-nav]');
  if (!wrap) return;

  var links = Array.prototype.slice.call(wrap.querySelectorAll('.sf-page-nav__link'));
  if (!links.length) return;

  var scrollOffset = parseInt(wrap.getAttribute('data-sf-nav-offset'), 10);
  if (isNaN(scrollOffset)) scrollOffset = 90;
  var triggerLine = parseInt(wrap.getAttribute('data-sf-nav-trigger'), 10);
  if (isNaN(triggerLine)) triggerLine = 150;

  var targets = [];
  links.forEach(function (link) {
    var id = link.getAttribute('data-sf-nav-target');
    var el = id ? document.getElementById(id) : null;
    if (el) targets.push({ link: link, el: el });
  });
  if (!targets.length) return;

  // Reveal-on-scroll: stay hidden on page load (while the top banner is
  // showing), then fade in once that banner has scrolled fully out of
  // view — and hide again if the reader scrolls back up to it. Looks for
  // a Surferelle Hero or Surferelle Banner section, whichever appears
  // first on the page; if neither is present, or the setting is off, the
  // nav is just shown right away like before.
  if (wrap.getAttribute('data-sf-nav-reveal') === '1') {
    var revealTarget = document.querySelector('.sf-hero, .sf-banner');
    if (revealTarget && 'IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        var entry = entries[entries.length - 1];
        wrap.classList.toggle('is-visible', !entry.isIntersecting);
      }, { threshold: 0 });
      revealObserver.observe(revealTarget);
    } else {
      wrap.classList.add('is-visible');
    }
  } else {
    wrap.classList.add('is-visible');
  }

  // Order by document position (not block order) so scroll-spy walks the
  // page top-to-bottom regardless of how the links are arranged in settings.
  targets.sort(function (a, b) {
    return a.el.getBoundingClientRect().top - b.el.getBoundingClientRect().top;
  });

  targets.forEach(function (t) {
    t.link.addEventListener('click', function (e) {
      e.preventDefault();

      // If the target is a collapsed Surferelle Stage, open it first.
      // Other stages are left exactly as they are — stages don't close
      // each other, so this never disturbs anything the reader already
      // had open elsewhere on the page.
      var details = t.el.querySelector('details.sf-stage');
      if (details && !details.open) {
        details.open = true;
      }

      // Give the accordion a moment to open (its height changes the
      // section's position) before measuring where to scroll to.
      window.setTimeout(function () {
        var top = t.el.getBoundingClientRect().top + window.scrollY - scrollOffset;
        window.scrollTo({ top: top, behavior: 'smooth' });
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + t.el.id);
        }
      }, 60);
    });
  });

  var setActive = function (activeEl) {
    targets.forEach(function (t) {
      t.link.classList.toggle('is-active', t.el === activeEl);
    });
  };

  // The active section is the last one whose top has scrolled above the
  // trigger line — robust for short/collapsed sections, since it depends
  // only on position rather than needing to linger inside a narrow band.
  var ticking = false;
  var updateActive = function () {
    ticking = false;
    var current = targets[0].el;
    for (var i = 0; i < targets.length; i++) {
      if (targets[i].el.getBoundingClientRect().top <= triggerLine) {
        current = targets[i].el;
      }
    }
    // Near the very bottom of the page, force the last section active even
    // if its top never crosses the trigger line (e.g. a short final section).
    var doc = document.documentElement;
    if (window.innerHeight + window.scrollY >= doc.scrollHeight - 2) {
      current = targets[targets.length - 1].el;
    }
    setActive(current);
  };
  var onScroll = function () {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(updateActive);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  updateActive();
});
